import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LoadScript } from '@react-google-maps/api';
import { ThemeProvider } from './context/ThemeContext';
import { HomePage } from './pages/HomePage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { DeletePage } from './pages/DeletePage';
import './App.css';

const GOOGLE_MAPS_LIBRARIES: ('places')[] = ['places'];
const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || 'backoffice';

function usePageTitle() {
  const location = useLocation();
  useEffect(() => {
    const titles: Record<string, string> = {
      '/delete': 'Delete Listing | GTA Rental',
      [`/${ADMIN_PATH}`]: 'Admin Login | GTA Rental',
      [`/${ADMIN_PATH}/dashboard`]: 'Admin Dashboard | GTA Rental',
    };
    document.title = titles[location.pathname] ?? 'GTA Rental Map | Find Rents in Greater Toronto Area';
  }, [location.pathname]);
}

function TitleManager() {
  usePageTitle();
  return null;
}

function MainApp() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState<string | null>(null);
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

  return (
    <LoadScript
      googleMapsApiKey={googleMapsApiKey}
      libraries={GOOGLE_MAPS_LIBRARIES}
      onLoad={() => setIsLoaded(true)}
      onError={(err) => setLoadError(`Failed to load Google Maps: ${err.message}`)}
    >
      <div className="App">
        {loadError && <div className="maps-error" role="alert">{loadError}</div>}
        {isLoaded ? (
          <HomePage />
        ) : !loadError ? (
          <div className="maps-loading" role="status" aria-live="polite">
            <h2>Loading GTA Rental Map…</h2>
            <p>This may take a moment</p>
          </div>
        ) : null}
      </div>
    </LoadScript>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <TitleManager />
        <Routes>
          <Route path={`/${ADMIN_PATH}`} element={<AdminLogin />} />
          <Route path={`/${ADMIN_PATH}/dashboard`} element={<AdminDashboard />} />
          <Route path="/delete" element={<DeletePage />} />
          <Route path="*" element={<MainApp />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
